import { CSSProperties } from 'react';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    zIndex: '1301 !important' as CSSProperties['zIndex'],
    position: 'fixed',
    top: 0,
    left: 0,
    padding: 8,
    minHeight: 'unset',
    transform: 'translateY(-150%)',
    transition: 'transform 120ms ease',
    '&:focus-visible': {
      transform: 'translateY(0)',
    },
  },
}));
